import React, { FunctionComponent, useState, useEffect, useCallback } from 'react';
import { getSalaryRangeText } from '../../../libs/salaryUtils';
import { Presentation } from './presentation';

type Props = {
  id: string;
  title: string;
  value: any;
  word: string;
  penIconImg: string;
  isShow: boolean;
  isPc?: boolean;
  last?: boolean;
  disabled?: boolean;
  unCompleted?: boolean;
  handleClick: (target: string, title: string) => void;
};

export const Component: FunctionComponent<Props> = ({
  id,
  title,
  value,
  word,
  penIconImg,
  isShow,
  isPc,
  last,
  disabled,
  unCompleted,
  handleClick,
}) => {
  const [internalValue, setInternalValue] = useState(value);

  useEffect(() => {
    if (value !== internalValue) {
      setInternalValue(value);
    }
  }, [value]);

  const onClickItem = useCallback((event: React.MouseEvent<HTMLDivElement>) => {
    const target = (event.currentTarget as HTMLDivElement).id;
    const titleElement = event.currentTarget.querySelector('.title') as HTMLElement;
    const titleText = titleElement?.innerText || '';
    handleClick(target, titleText);
  }, [handleClick]);

  const shouldDisplay = () => {
    if (value === '' || value === undefined || value === null) {
      return isShow;
    }
    // else if (id === 'birthday') {
    //   return isShow;
    // }
    return true;
  };

  const isEmptySelection = () => value === '' || value === null;

  const isOccupation = id === 'currentOccupations';
  const isSalary = id === 'salary';

  return (
    <Presentation
      id={id}
      title={title}
      value={value}
      word={word}
      penIconImg={penIconImg}
      isShow={isShow}
      isPc={isPc}
      last={last}
      disabled={disabled}
      unCompleted={unCompleted}
      onClickItem={onClickItem}
      isDisplay={shouldDisplay()}
      isSelection={isEmptySelection()}
      isOccupation={isOccupation}
      isSalary={isSalary}
      salaryWord={getSalaryRangeText}
    />
  );
};
